"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../../styled"));
var tokens_1 = require("../../../tokens");
var form_context_1 = __importDefault(require("../form-context"));
var button_1 = __importDefault(require("../../../atoms/button"));
var button_group_1 = __importDefault(require("../../../molecules/button-group"));
var getButtonProps = function (action) {
    var props = __assign({}, action);
    props.icon = action.icon;
    props.onClick = action.handler;
    delete props.label;
    return props;
};
var Actions = function (props) {
    var primaryAction = props.primaryAction, secondaryActions = props.secondaryActions, destructiveAction = props.destructiveAction;
    return (React.createElement(form_context_1.default.Consumer, null, function (context) { return (React.createElement(Actions.Element, { layout: context.layout, fullWidth: context.fullWidth },
        React.createElement(button_group_1.default, null,
            primaryAction && (React.createElement(button_1.default, __assign({}, getButtonProps(primaryAction), { appearance: "primary" }), primaryAction.label)),
            secondaryActions &&
                secondaryActions.map(function (action, index) { return (React.createElement(button_1.default, __assign({}, getButtonProps(action), { type: "button", appearance: "secondary", key: index }), action.label)); }),
            destructiveAction && (React.createElement(button_1.default, __assign({}, getButtonProps(destructiveAction), { appearance: "destructive" }), destructiveAction.label))))); }));
};
Actions.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  margin-top: ", ";\n  grid-gap: ", ";\n  @media (min-width: 768px) {\n    grid-template-columns: ", ";\n\n    ", " {\n      grid-column-start: ", ";\n    }\n  }\n"], ["\n  display: grid;\n  margin-top: ", ";\n  grid-gap: ", ";\n  @media (min-width: 768px) {\n    grid-template-columns: ", ";\n\n    ", " {\n      grid-column-start: ", ";\n    }\n  }\n"])), tokens_1.spacing.xlarge, function (props) { return (props.layout === 'label-on-left' ? '25px' : '0'); }, function (props) { return (props.layout === 'label-on-left' ? '200px 1fr' : '1fr'); }, button_group_1.default.Element, function (props) { return (props.layout === 'label-on-left' ? '2' : '1'); });
Actions.displayName = 'Form Actions';
Actions.defaultProps = {};
var StyledActions = Actions.Element;
exports.StyledActions = StyledActions;
exports.default = Actions;
var templateObject_1;
//# sourceMappingURL=actions.js.map